// ===============================
// features/appbar/Appbar.jsx
// ===============================
import { StyledAppBar } from "./style/appbar.styles";
import UpperNav from "./components/UpperNav";
// import NavDesktop from "./components/NavDesktop";
import NavMobile from "./components/NavMobile";

import { useAuth } from "../../contexts/AuthContext";
import { useCartStore } from "../cart/hooks/useCartStore";
import { useAppbar } from "./hooks/useAppbar";

export default function Appbar() {
  const auth = useAuth();
  const cartProducts = useCartStore((state) => state.cartProducts);

  const { drawerOpen, toggleDrawer, closeDrawer, scrolled, isDesktop } =
    useAppbar();

  return (
    <StyledAppBar position="sticky" scrolled={scrolled}>
      <UpperNav
        isDesktop={isDesktop}
        toggleDrawer={toggleDrawer}
        scrolled={scrolled}
        cartCount={cartProducts.length}
      />

      <NavMobile open={drawerOpen} onClose={closeDrawer} auth={auth} />
    </StyledAppBar>
  );
}
